export const formatDate = (dateString) => {
    if (!dateString) return '-'
  
    const date = new Date(dateString)
  
    const hari = new Intl.DateTimeFormat('id-ID', {
      weekday: 'long',
      timeZone: 'Asia/Jakarta',
    }).format(date)
  
    const tanggal = new Intl.DateTimeFormat('id-ID', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
      timeZone: 'Asia/Jakarta',
    })
      .format(date)
      .replace(/\//g, '-')
  
    return `${capitalize(hari)}, ${tanggal}`
  }
  
  /**
   * Kapital huruf awal
   */
  const capitalize = (text) => {
    return text.charAt(0).toUpperCase() + text.slice(1)
  }